import { render, staticRenderFns } from "./addDBJG.vue?vue&type=template&id=29b90cf5&scoped=true&"
import script from "./addDBJG.vue?vue&type=script&lang=js&"
export * from "./addDBJG.vue?vue&type=script&lang=js&"
import style0 from "./addDBJG.vue?vue&type=style&index=0&id=29b90cf5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b90cf5",
  null
  
)

export default component.exports